import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet, apiDelete, apiPatch,
} from '../../../../middleware/api';
import {
  GET_VOLCANO_EVENT_DATA_REGION_REQUEST,
  DELETE_VOLCANO_EVENT_DATA_REQUEST,
  DELETE_VOLCANO_EVENT_DATA_FAILURE,
  DELETE_VOLCANO_EVENT_DATA_SUCCESS,
  GET_VOLCANO_EVENT_DATA_REGION_FAILURE,
  GET_VOLCANO_EVENT_DATA_REGION_SUCCESS,
  VOLCANO_EVENT_DATA_BULK_EDIT_FAILURE,
  VOLCANO_EVENT_DATA_BULK_EDIT_REQUEST,
  VOLCANO_EVENT_DATA_BULK_EDIT_SUCCESS,
} from './volcanoEventDataReducer';


const bulkEditVolcanoEventsSaga = createApiSaga({
  apiFunction: apiPatch,
  generateApiConfig: action => ({ endpoint: '/volcanoes', ...action }),
  requestType: VOLCANO_EVENT_DATA_BULK_EDIT_REQUEST,
  successType: VOLCANO_EVENT_DATA_BULK_EDIT_SUCCESS,
  failureType: VOLCANO_EVENT_DATA_BULK_EDIT_FAILURE,
  successMessage: 'Saved',
});


const deleteVolcanoEventSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}`, ...action }),
  requestType: DELETE_VOLCANO_EVENT_DATA_REQUEST,
  successType: DELETE_VOLCANO_EVENT_DATA_SUCCESS,
  failureType: DELETE_VOLCANO_EVENT_DATA_FAILURE,
  successMessage: 'Deleted',
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: GET_VOLCANO_EVENT_DATA_REGION_REQUEST,
  successType: GET_VOLCANO_EVENT_DATA_REGION_SUCCESS,
  failureType: GET_VOLCANO_EVENT_DATA_REGION_FAILURE,
});

export const volcanoEventDataSagas = [
  bulkEditVolcanoEventsSaga,
  deleteVolcanoEventSaga,
  getRegionsSaga,
];
